import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";

const Carregando = (props) => (
	<div className="page-loading">
		<LinearProgress variant="indeterminate" />
	</div>
);
export default Carregando;
